/* ===== LP Les Magnifiques - onglets PlayShorts + barre mobile ===== */
(function () {
  function initOnglets(root) {
    if (!root || root.dataset.mgInit) return;
    root.dataset.mgInit = '1';
    var tabs = [].slice.call(root.querySelectorAll('.mg-tab'));
    if (!tabs.length) return;

    function activer(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) {
          p.classList.toggle('mg-panel--off', !on);
          p.inert = !on;
          if (on) p.removeAttribute('aria-hidden'); else p.setAttribute('aria-hidden', 'true');
        }
      });
      if (focus) tab.focus();
      var bar = tab.parentNode;
      if (bar.scrollWidth > bar.clientWidth) {
        bar.scrollTo({ left: tab.offsetLeft - 18, behavior: 'smooth' });
      }
      window.dispatchEvent(new Event('resize'));
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activer(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var c = null;
        if (e.key === 'ArrowRight') c = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') c = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') c = tabs[0];
        if (e.key === 'End') c = tabs[tabs.length - 1];
        if (c) { e.preventDefault(); activer(c, true); }
      });
    });

    function depuisAncre() {
      var h = decodeURIComponent(location.hash.replace('#', ''));
      var t = tabs.filter(function (x) { return x.dataset.handle === h; })[0];
      if (t) { activer(t, false); root.scrollIntoView(); }
    }
    depuisAncre();
    window.addEventListener('hashchange', depuisAncre);
    root._mgActiver = function (id) {
      var t = tabs.filter(function (x) { return x.dataset.blockId === id; })[0];
      if (t) activer(t, false);
    };
  }

  function initBarre() {
    var barre = document.querySelector('[data-mg-barre]');
    if (!barre || barre.dataset.mgInit || !('IntersectionObserver' in window)) return;
    barre.dataset.mgInit = '1';
    var hero = document.querySelector('[data-mg-hero]');
    var cible = document.querySelector('[data-mg-gamme]');
    var heroVisible = true, gammeVisible = false;
    function maj() { barre.classList.toggle('is-visible', !heroVisible && !gammeVisible); }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.target === hero) heroVisible = e.isIntersecting;
        if (e.target === cible) gammeVisible = e.isIntersecting;
      });
      maj();
    }, { threshold: 0 });
    if (hero) io.observe(hero); else heroVisible = false;
    if (cible) io.observe(cible);
    maj();
  }

  function initAll() {
    document.querySelectorAll('[data-mg-videos]').forEach(initOnglets);
    initBarre();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-mg-videos]').forEach(initOnglets);
    initBarre();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-mg-videos]');
    if (root && root._mgActiver) root._mgActiver(e.detail.blockId);
  });
})();
